/* React, ReactDOM, serviceWorker imports */
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
/* Theme material ui, css, imports */
import { MuiThemeProvider } from '@material-ui/core'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { theme } from './Frontend/Login/theme'
import './index.css'
// import { ReactQueryDevtools } from 'react-query-devtools'
import { QueryCache, ReactQueryCacheProvider } from 'react-query'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

// Define the keys for each environment
const stripeKeys = {
  production: 'pk_kB28CGfcte39S7jmZrVeGCyGMIxt7',
  qa: 'pk_hVVkmHqawzjU4zVcBbsjsEKldDMml'
}

const recaptchaKeys = {
  production: '6LdWg2YrAAAAAAYXfWbXXwjUlvQkVkQG4kowAzMC', // from Google admin console (v3)
  qa: '6LdWg2YrAAAAAAYXfWbXXwjUlvQkVkQG4kowAzMC'
}

// Determine the environment based on the hostname
const environment =
  window.location.hostname.includes('qa') ||
  window.location.hostname === 'localhost'
    ? 'qa'
    : 'production'

// Dynamically set the stripeKey
const stripeKey = stripeKeys[environment]
const recaptchaSiteKey = recaptchaKeys[environment]

// Must make the stripe key enviroment dependable so it's not exposed and it's dinamically seeded
const stripePromise = loadStripe(stripeKey)

const queryCache = new QueryCache({
  defaultConfig: { queries: { staleTime: 1 * 60 * 10, retry: 1 } }
})

ReactDOM.render(
  /* Theme Material */
  <ReactQueryCacheProvider queryCache={queryCache}>
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    <Elements stripe={stripePromise}>
      <MuiThemeProvider theme={theme}>
        <GoogleReCaptchaProvider
          reCaptchaKey={recaptchaSiteKey}
          scriptProps={{ async: true, defer: true }} // non-blocking load
        >
          <App />
        </GoogleReCaptchaProvider>
      </MuiThemeProvider>
    </Elements>
  </ReactQueryCacheProvider>,
  document.getElementById('root')
)
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
